import Reflux from 'reflux'
import ToolBarActions from '../actions/ToolBarActions'

var ToolBarUpdateGridToolBarStore = Reflux.createStore(
{
	init:function(){this.listenTo(ToolBarActions.updateGridToolBar,'onUpdateGridToolBar')},
    onUpdateGridToolBar(_value)
    {
		this.trigger(_value);
    }
});

export default ToolBarUpdateGridToolBarStore;


// WEBPACK FOOTER //
// ./src/stores/ToolBarUpdateGridToolBarStore.js